
const WtfIsThis = () => {
   return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-8 relative" id="Wit">
        <h1 className="text-3xl font-bold mb-4 text-red-600">WTF is this?</h1>
        <p className="text-lg mb-4">This is a website where you can enter your wishes and, if you are lucky enough, you can win prizes. What does it cost you? Nothing! Absolutely nothing. Just register and be consistent with giving wishes daily, and you might have a chance.</p>
        <p className="text-lg mb-4">How do we earn? We run ads. Ad revenue is a huge part of the website, which makes such a thing possible.</p>
        <p className="text-lg font-semibold absolute bottom-20 right-20">Yours truly, Partheev.</p>
    </div>
   )
};

export default WtfIsThis;
